import { render } from "./component.vue?vue&type=template&id=94c8e5de"
const script = {}

import "./component.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__